import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { pageRoutes } from '../../managerRoutes';
import { Card, CardBody, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { breakpoints } from '../../helpers/utils';
import { topNavbarBreakpoint } from '../../config';
import { useSelector } from 'react-redux';

const NavbarTopDropDownMenus = ({ setNavbarCollapsed }) => {
  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
  }

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
  const { selectedCondominium } = useSelector(state => state.condominium);
  const { role } = useSelector(state => state.auth.user);

  return (
    <>
      {role !== 'safety' && role !== 'provider' &&
      <NavItem onClick={handleSetNavbarCollapsed}>
        <NavLink tag={Link} to="/dashboard/app">
          Inicio
        </NavLink>
      </NavItem>}

      {role === 'manager' &&
        <NavItem onClick={handleSetNavbarCollapsed}>
          <NavLink tag={Link} to="/dashboard/condominiums">
            Condominios
          </NavLink>
        </NavItem>}

      {(selectedCondominium) && role !== 'root' && role !== 'safety' && <NavItem onClick={handleSetNavbarCollapsed}>
        <NavLink tag={Link} to="/dashboard/feed">
          Muro
        </NavLink>
      </NavItem>}
      {(selectedCondominium) && role !== 'root' && role !== 'safety' && <NavItem onClick={handleSetNavbarCollapsed}>
        <NavLink tag={Link} to="/dashboard/release">
          Comunicados
        </NavLink>
      </NavItem>}

      {(selectedCondominium && role === 'manager') && <Dropdown
        nav
        inNavbar
        isOpen={dropdownOpen}
        toggle={toggleDropdown}
        onMouseOver={() => {
          let windowWidth = window.innerWidth;
          if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
            setDropdownOpen(true);
          }
        }}
        onMouseLeave={() => {
          let windowWidth = window.innerWidth;
          if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
            setDropdownOpen(false);
          }
        }}
      >
        <DropdownToggle nav caret>
          {pageRoutes.name}
        </DropdownToggle>
        <DropdownMenu right={false} className="dropdown-menu-card mt-0">
          <Card
            className={'shadow-none max-h-dropdown'}
          >
            <CardBody className='scrollbar'>
              <div className="nav flex-column">
                {pageRoutes.children.map(({ to, name }, index) => (
                  <DropdownItem tag={Link} to={to} key={index} onClick={handleSetNavbarCollapsed}>
                    {name}
                  </DropdownItem>
                ))}
              </div>
            </CardBody>
          </Card>
        </DropdownMenu>
      </Dropdown>}
    </>
  )
}

NavbarTopDropDownMenus.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default NavbarTopDropDownMenus;